import { useEffect, useState, useMemo } from 'react';
import { GoogleDriveService, GoogleDriveFile } from '../Services/googleDrive';

interface UseGoogleDriveFilesReturn {
  files: GoogleDriveFile[];
  apkFiles: GoogleDriveFile[];
  error: string;
  loading: boolean;
  refetch: () => void;
}

export function useGoogleDriveFiles(): UseGoogleDriveFilesReturn {
  const [files, setFiles] = useState<GoogleDriveFile[]>([]);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  
  const apkFiles = useMemo(() => 
    files.filter(file => 
      file.name.toLowerCase().endsWith('.apk') || 
      file.mimeType.includes('vnd.android.package-archive')
    ), [files]
  );

  const fetchFiles = async () => {
    try {
      setLoading(true);
      setError('');
      const filesData = await GoogleDriveService.listFiles();
      setFiles(filesData);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao carregar arquivos';
      setError(errorMessage);
      setFiles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const refetch = () => {
    fetchFiles();
  };

  return {
    files,
    apkFiles,
    error,
    loading,
    refetch
  };
}
